<template>

    <div>
        <!-- mobile back to login -->
        <div class="dn-ns dn-m dn-l pa3 bb b--light-gray">
            <BackLink @click="$emit('backClick')">Back to log in</BackLink>
        </div>

        <div class="pa3">

            <!-- action description -->
            <h6>Forgot your password?</h6>
            <div class="mt2 bodyCopy">
                Enter your email address below and we'll get you back on track.
            </div>

            <!-- input field -->
            <input class="mt3 mb2 pa2 w-100" v-model="email" type="email" name="email" placeholder="Email Address"/>

            <!-- button -->
            <TooliabaButton @click="passwordEmail(email).then(x => {$emit('sendClick')})">Request Reset Link</TooliabaButton>

            <!-- desktop back to login -->
            <div class=" dn db-ns db-m db-l tc mt3">
                <BackLink :addCaret="false" @click="$emit('backClick')">Go back to log in</BackLink>
            </div>

        </div>
    </div>

</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import BackLink from '@/components/controls/BackLink.vue';
import { mapActions } from 'vuex';

export default {
    components: {
        TooliabaButton,
        BackLink
    },
    data: function() {
        return {
            email: ''
        };
    },
    methods: {
        ...mapActions('users', ['passwordEmail'])
    }
};
</script>
